import(/* webpackMode: "eager" */ "/usr/src/app/apps/main/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/apps/main/components/gtm-body/GtmBody.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/apps/main/components/gtm-head/GtmHead.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/apps/main/components/header/HeaderSelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/apps/main/components/page-transition/PageTransition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/apps/main/components/reveal-scroll/RevealOnScroll.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/packages/ui/dist/index.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"adjustFontFallback\":true,\"preload\":true}],\"variableName\":\"inter\"}");
